import { takeEvery, fork, put, all, call } from "redux-saga/effects"
import axiosInstance from "pages/Utility/axiosInstance"

//Account Redux states
import { REGISTER_USER, VENDOR_REGISTER } from "./actionTypes"
import { registerUserSuccessful, registerUserFailed, vendorRegisterSuccessful, vendorRegisterFailed } from "./actions"

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper"
import {
  postFakeRegister,
  postJwtRegister,
  postVendorRegister
} from "../../../helpers/fakebackend_helper"

// initialize relavant method of both Auth
const fireBaseBackend = getFirebaseBackend()

const vendorRegisterApi = data => axiosInstance.post('/V1/auth/vendor/register', data, {
    headers: {
        'Content-Type': 'multipart/form-data',
    },
})

// Is user register successfull then direct plot user in redux.
function* registerUser({ payload: { user } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(
        fireBaseBackend.registerUser,
        user.email,
        user.password
      )
      yield put(registerUserSuccessful(response))
    } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      const response = yield call(postJwtRegister, "/post-jwt-register", user)
      yield put(registerUserSuccessful(response))
    } else if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
      const response = yield call(postFakeRegister, user)
      yield put(registerUserSuccessful(response))
    }
  } catch (error) {
    yield put(registerUserFailed(error))
  }
}

function* vendorRegister({ payload: { user, navigate } }) {
  try {
    const response = yield call(vendorRegisterApi, user)
    yield put(vendorRegisterSuccessful(response.data))
    if (navigate) {
      navigate('/login')
    }
  } catch (error) {
    yield put(vendorRegisterFailed(error))
  }
}

export function* watchUserRegister() {
  yield takeEvery(REGISTER_USER, registerUser)
  yield takeEvery(VENDOR_REGISTER, vendorRegister)
}

function* accountSaga() {
  yield all([fork(watchUserRegister)])
}

export default accountSaga
